import React from 'react';
import {Props} from './model';
import {ViewMobile} from './viewMobile';
import {ViewDesktop} from './viewDesktop';
import {useIsDesktop} from '../../hooks/useIsDesktop';

export const Swiper: React.FC<Props> = (props) => {
  const isDesktop = useIsDesktop();
  const View = isDesktop ? ViewDesktop : ViewMobile;
  return <View {...props} />;
};
